import { useMemo } from "react";

import { useGetSomeIngredientReferencesUnified } from "src/api/client-api/ingredientReferenceUnified/useGetSomeIngredientReferencesUnified";
import type { ProductFormProductIngredient } from "src/pages/Product/ProductForm/ProductForm.types";

import { collectIngredientReferenceCompositeIds, type EcobalyseIngredientMassRatiosMap } from "./ecobalyseMass";

const buildRatiosMap = (
    ingredientReferences: ReturnType<typeof useGetSomeIngredientReferencesUnified>["ingredientReferences"],
): EcobalyseIngredientMassRatiosMap => {
    const ratiosByCompositeId = new Map<
        string,
        { nonEdiblePartRatio?: number | null; rawToCookedRatio?: number | null }
    >();

    for (const reference of ingredientReferences ?? []) {
        ratiosByCompositeId.set(reference.compositeId, {
            nonEdiblePartRatio: reference.nonEdiblePartRatio ?? null,
            rawToCookedRatio: reference.rawToCookedRatio ?? null,
        });
    }

    return ratiosByCompositeId;
};

export const useIngredientMassRatios = (
    productIngredients: ProductFormProductIngredient[],
): EcobalyseIngredientMassRatiosMap => {
    const compositeIds = useMemo(
        () => collectIngredientReferenceCompositeIds(productIngredients),
        [productIngredients],
    );

    const { ingredientReferences } = useGetSomeIngredientReferencesUnified(compositeIds);

    return useMemo(() => buildRatiosMap(ingredientReferences), [ingredientReferences]);
};
